import React, { useState, useEffect, useRef, useCallback } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { useDispatch } from "react-redux";
import Modal from "../../components/modal/Modal";
import { handleGetRequest } from "../../services/GetTemplate";
import { handleDeleteRequest } from "../../services/DeleteTemplate";
import editIcon from "../../../src/assets/png/edit.png";
import deleteIcon from "../../../src/assets/png/delete.png";
import viewIcon from "../../assets/png/view.png";
import Loading from "../../components/Loader";
import AddParts from "./Components/AddParts";
import EditViewParts from "./Components/EditViewParts";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { Dropdown } from "primereact/dropdown";
import NavigationComponent from "../../components/NavigationComponent";
import Paginator from "../../components/Paginator";
import { toast } from "react-toastify";
import axios from "axios";
import baseURL, { endPoints } from "../../Config";
import { handlePatchRequest } from "../../services/PatchTemplate";

const ManagePart = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [switchModal, setSwitchModal] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [allParts, setAllParts] = useState([]);
    const [partsData, setPartsData] = useState([]);
    const [partsdataId, setPartsDataId] = useState();
    const [displayDialog, setDisplayDialog] = useState(false);
    const [currentModal, setCurrentModal] = useState(null);
    const [isEditable, setIsEditAble] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [statusValue, setStatusValue] = useState("all");
    const [isUploading, setIsUploading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [searchInput, setSearchInput] = useState("");
    const [searchText, setSearchText] = useState("");
    const [isSearching, setIsSearching] = useState(false);
    const searchTimeoutRef = useRef(null);
    const searchInputRef = useRef(null);
    const [shouldMaintainFocus, setShouldMaintainFocus] = useState(false);
    const [wasSearching, setWasSearching] = useState(false);

    //paginator
    const [recordCount, setRecordCount] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [quotationsCount, setQuotationsCount] = useState(0);

    const statusOptions = [
        { id: "all", name: "All" },
        { id: "active", name: "Active" },
        { id: "inactive", name: "Inactive" },
    ];

    const dispatch = useDispatch();

    const userIdStr = localStorage.getItem("rememberMe") === "y" ? localStorage.getItem("userDetails") : sessionStorage.getItem("userDetails");

    const userId = JSON.parse(userIdStr);
    const userRole = userId?.data?.roleName;

    const handleInputSwitch = async () => {
        setLoadingBtn(true);

        let newdata = {
            id: switchData?.partId,
            isActive: switchData?.partIsActive ? false : true,
        };

        const response = await dispatch(handlePatchRequest(newdata, endPoints.partStatus, false, true));

        if (response?.statusCode === 200) {
            getPartList();
        }
        setLoadingBtn(false);
        handleSwitchModalClose();
    };
    const statusTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                <InputSwitch
                    className="edit-btn ml-1 mt-2"
                    checked={rowData.partIsActive === true}
                    onChange={() => {
                        handleSwitchModalOpen();
                        setSwitchData(rowData);
                    }}
                />
            </div>
        );
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                {!userRole?.toLowerCase().includes("user") && (
                    <Button className="edit-btn ml-1 px-2" onClick={() => handleEditParts(rowData)}>
                        <img src={editIcon} alt="Edit" />
                    </Button>
                )}

                <Button className="edit-btn ml-1 px-2" onClick={() => handleViewPart(rowData)}>
                    <img src={viewIcon} alt="view" />
                </Button>
                {!userRole?.toLowerCase().includes("user") && (
                    <Button
                        className="edit-btn ml-1 px-2"
                        onClick={() => {
                            handleOpenModal();
                            setPartsDataId(rowData.partId);
                        }}
                    >
                        <img src={deleteIcon} alt="Delete" />
                    </Button>
                )}
            </div>
        );
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };
    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const onHide = () => {
        setCurrentModal(null);
        setDisplayDialog(false);
    };

    const handleDialog = () => {
        setCurrentModal("Add");
        setDisplayDialog(true);
    };

    const handleEditParts = (rowData) => {
        setCurrentModal("EditView");
        setDisplayDialog(true);
        setIsEditAble(true);
        setPartsDataId(rowData?.partId);
    };

    const handleViewPart = (rowData) => {
        setCurrentModal("EditView");
        setDisplayDialog(true);
        setIsEditAble(false);
        setPartsDataId(rowData?.partId);
    };
    const getPartList = async () => {
        setLoading(true);
        const params = new URLSearchParams({
            PageSize: recordCount?.toString(),
            PageNumber: currentPage?.toString(),
            Filter: searchText,
            IsActive: statusValue === "all" ? "" : statusValue === "inactive" ? 0 : 1,
        });
        const response = await dispatch(handleGetRequest(endPoints.getallParts(params), false));
        if (response) {
            const items = response?.data?.items || [];
            const totalCount = response?.data?.totalCount || 0;
            setAllParts(items);
            setQuotationsCount(totalCount);
            setTotalPageCount(Math.ceil(totalCount / recordCount));
        }
        setLoading(false);
        setIsSearching(false);

        // Maintain focus on search input after API call completes
        if (shouldMaintainFocus && searchInputRef.current) {
            setTimeout(() => {
                searchInputRef.current.focus();
                setShouldMaintainFocus(false);
            }, 0);
        }
    };

    // Debounced search function
    const debouncedSearch = useCallback((value) => {
        // Clear existing timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        // Set new timeout
        searchTimeoutRef.current = setTimeout(() => {
            setSearchText(value);
            setCurrentPage(1); // Reset to first page when searching
            setShouldMaintainFocus(true); // Flag to maintain focus after API call
            setWasSearching(true); // Track that we're about to search
        }, 500); // 500ms delay
    }, []);

    // Handle search input change
    const handleSearchInputChange = (e) => {
        const value = e.target.value;
        setSearchInput(value);

        // Only set searching state if there's actual text to search
        if (value.trim().length > 0) {
            setIsSearching(true);
        } else {
            setIsSearching(false);
        }

        debouncedSearch(value);
    };

    // Handle search input focus
    const handleSearchInputFocus = () => {
        setShouldMaintainFocus(true);
    };

    // Handle search input click to ensure focus
    const handleSearchInputClick = () => {
        setShouldMaintainFocus(true);
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    };
    useEffect(() => {
        getPartList();
    }, [currentPage, recordCount, statusValue, searchText]);

    // Monitor loading state and restore focus when loading completes
    useEffect(() => {
        if (wasSearching && !loading && !isSearching && searchInputRef.current) {
            // Small delay to ensure DOM is updated
            const timer = setTimeout(() => {
                searchInputRef.current.focus();
                setWasSearching(false);
            }, 50);
            return () => clearTimeout(timer);
        }
    }, [loading, isSearching, wasSearching]);

    // Cleanup timeout on component unmount
    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
            setShouldMaintainFocus(false);
        };
    }, []);

    const handleDeleteParts = async () => {
        setLoadingBtn(true);
        const response = await dispatch(handleDeleteRequest(endPoints.deletePart(partsdataId), true, true));
        if (response?.statusCode === 200) {
            getPartList();
        }
        setLoadingBtn(false);
        handleCloseModal();
    };

    const variantTemplate = (rowData) => {
        return <div>{rowData?.variants?.map((item) => item.variantName).join(", ")}</div>;
    };
    const optionTemplate = (option) => {
        return <div className={option.className}>{option.name}</div>;
    };
    const selectedItemTemplate = (option) => {
        if (option) {
            return <div className={option.className}>{option.name}</div>;
        }
        return <span>Select Status</span>;
    };
    const ImageTemplate = (rowData) => {
        let imageUrl = rowData?.imgPath;
        return (
            <React.Fragment>
                <img style={{ borderRadius: "10px" }} src={`${baseURL}/${imageUrl}`} width="70px" height="45px" alt="Part Image" />
            </React.Fragment>
        );
    };
    const costTemplate = (rowData) => {
        return ` ${rowData?.partCost} ${rowData?.currencyCode}`;
    };
    const createdDateAndTimeBodyTemplate = (rowData) => {
        const isoDate = rowData?.partCreatedDate;
        const date = new Date(isoDate);

        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const yyyy = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");

        let ampm = "AM";
        if (hours >= 12) {
            ampm = "PM";
            hours -= 12;
        }
        if (hours === 0) {
            hours = 12;
        }

        const formattedDateTime = `${dd}/${mm}/${yyyy} ${hours}:${minutes} ${ampm}`;
        return <p>{formattedDateTime}</p>;
    };

    const headerText = currentModal === "Add" ? "Add Part" : isEditable === true ? "Edit Part" : "View Part";
    const header = <span className="title-border">{headerText}</span>;

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]); // Store the selected file in statess
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            alert("Please select a file first!");
            return;
        }
        const formData = new FormData();
        formData.append("file", selectedFile);
        setIsUploading(true);

        try {
            const response = await axios.post(`${baseURL}/api/v1/parts/uploadInventoryData`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.status == 200) {
                setIsUploading(false);
                setSelectedFile(false);
                toast.success(response?.data?.message);
                await getPartList();
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            toast.error(error.message);
        }
    };

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <>
                    <Dialog resizable={false} header={header} visible={displayDialog} blockScroll style={{ width: "50vw" }} maskClassName="zindex8888" onHide={() => onHide()} draggable={false}>
                        {currentModal === "Add" ? <AddParts onHide={onHide} getPartList={getPartList} /> : currentModal === "EditView" && <EditViewParts onHide={onHide} partsdataId={partsdataId} getPartList={getPartList} isEditable={isEditable} />}
                    </Dialog>

                    <div>
                        <Modal isOpen={isModalOpen} onClose={handleCloseModal} onConfirm={handleDeleteParts} rowData={partsData} type="delete" loadingBtn={loadingBtn} headerText="Are you sure you want to delete this Part?" />
                    </div>
                    <div>
                        <Modal
                            isOpen={switchModal}
                            onClose={handleSwitchModalClose}
                            onConfirm={handleInputSwitch}
                            type="active/inactive"
                            loadingBtn={loadingBtn}
                            rowData={switchData}
                            isActive={switchData?.partIsActive}
                            headerText={`Are you sure you want to ${switchData?.partIsActive ? "Inactive" : "Active"} this Part?`}
                        />
                    </div>
                    <NavigationComponent title={`Parts Management`} addNewHandleDialog={handleDialog} />

                    <div className="card-ml-1 dark-bg pt-3">
                        {!selectedFile ? (
                            <>
                                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                    <input type="file" id="fileInput" width={"50px"} accept=".xlsx" onChange={handleFileChange} style={{ display: "none" }} />
                                    {/* <Button label="Upload XLS" className="Btn_Upload " icon="pi pi-plus-circle" iconPos="left" onClick={() => document.getElementById("fileInput").click()} /> */}
                                </div>
                            </>
                        ) : isUploading ? (
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                <Button label="Uploading..." className="Btn_Upload ml-2" icon="pi pi-spin pi-spinner" disabled />
                            </div>
                        ) : (
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                <Button label="Submit" className="Btn_Upload ml-2" onClick={handleUpload} icon="pi pi-upload" iconPos="left" />
                            </div>
                        )}
                        {/* Search and Filter Controls - Outside DataTable to prevent re-renders */}
                        <div className="flex justify-content-end custom-alignment mb-3" style={{ display: "flex", alignItems: "center" }}>
                            <span className="mr-2 font-semibold text-base resp-status">Status:</span>
                            <Dropdown
                                className="mr-2"
                                style={{ width: "215px" }}
                                options={statusOptions}
                                optionLabel="name"
                                optionValue="id"
                                value={statusValue}
                                onChange={(e) => setStatusValue(e.target.value)}
                                placeholder="Select Status"
                                itemTemplate={optionTemplate}
                                valueTemplate={selectedItemTemplate}
                            />
                            <div className="search-container mr-4">
                                <InputText ref={searchInputRef} key="search-input" className="input-field" placeholder="Search..." value={searchInput} onChange={handleSearchInputChange} onFocus={handleSearchInputFocus} onClick={handleSearchInputClick} autoComplete="off" />
                                {(loading || isSearching) && <i className="pi pi-spin pi-spinner search-spinner" style={{ marginLeft: "8px", color: "#007bff" }}></i>}
                            </div>
                        </div>

                        {/* <DataTable responsive={true} responsiveLayout="scroll" stripedRows value={allParts} emptyMessage="No records found">
                            <Column body={ImageTemplate} header="Image" style={{ width: "150px" }} />
                            <Column field="partId" header="Part Number" style={{ width: "150px" }} />
                            <Column field="partName" header="Part Name" style={{ width: "150px" }} bodyStyle={{ textAlign: "center", overflow: "visible" }} />
                            <Column field="makerName" header="Maker Name" style={{ width: "150px" }} bodyStyle={{ textAlign: "center", overflow: "visible" }} />
                            <Column field="partVariantModelName" header="Model Name" style={{ width: "150px" }} />
                            <Column field="skuNo" header="SKU Number" style={{ width: "150px" }} />
                            <Column body={variantTemplate} header="Variant Name" style={{ width: "150px" }} />
                            <Column body={costTemplate} header="Cost" style={{ width: "150px" }} />
                            <Column body={createdDateAndTimeBodyTemplate} header="Created On" style={{ width: "190px" }} />
                            {!userRole?.toLowerCase().includes("user") && <Column body={statusTemplate} header="Status" style={{ width: "90px" }} />}
                            <Column body={actionTemplate} header="Action" style={{ width: "150px" }} />
                        </DataTable> */}
                        <DataTable
    responsive={true}
    responsiveLayout="scroll"
    stripedRows
    value={allParts}
    emptyMessage="No records found"
>
    {/* Image Column */}
    <Column
        body={(rowData) =>
            rowData?.imgPath ? (
                <img
                    style={{ borderRadius: "10px" }}
                    src={`${baseURL}/${rowData.imgPath}`}
                    width="70px"
                    height="45px"
                    alt="Part Image"
                />
            ) : (
                "N/A"
            )
        }
        header="Image"
        style={{ width: "150px" }}
    />

    {/* Part Number */}
    <Column
        field="partId"
        header="Part Number"
        body={(rowData) => rowData?.partId || "N/A"}
        style={{ width: "150px" }}
    />

    {/* Part Name */}
    <Column
        field="partName"
        header="Part Name"
        body={(rowData) => rowData?.partName || "N/A"}
        style={{ width: "150px" }}
    />

    {/* Maker Name */}
    <Column
        field="makerName"
        header="Maker Name"
        body={(rowData) => rowData?.makerName || "N/A"}
        style={{ width: "150px" }}
    />

    {/* Model Name */}
    <Column
        field="partVariantModelName"
        header="Model Name"
        body={(rowData) => rowData?.partVariantModelName || "N/A"}
        style={{ width: "150px" }}
    />

    {/* SKU Number */}
    <Column
        field="skuNo"
        header="SKU Number"
        body={(rowData) => rowData?.skuNo || "N/A"}
        style={{ width: "150px" }}
    />

    {/* Variant Name */}
    <Column
        body={(rowData) =>
            rowData?.variants?.length
                ? rowData.variants.map((item) => item.variantName).join(", ")
                : "N/A"
        }
        header="Variant Name"
        style={{ width: "150px" }}
    />

    {/* Cost */}
    <Column
        body={(rowData) =>
            rowData?.partCost
                ? `${rowData.partCost} ${rowData.currencyCode || ""}`
                : "N/A"
        }
        header="Cost"
        style={{ width: "150px" }}
    />

    {/* Created On */}
    <Column
        body={(rowData) => {
            if (!rowData?.partCreatedDate) return "N/A";
            const date = new Date(rowData.partCreatedDate);
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            const yyyy = date.getFullYear();
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, "0");
            let ampm = hours >= 12 ? "PM" : "AM";
            hours = hours % 12 || 12;
            return `${dd}/${mm}/${yyyy} ${hours}:${minutes} ${ampm}`;
        }}
        header="Created On"
        style={{ width: "190px" }}
    />

    {/* Status (if not user) */}
    {!userRole?.toLowerCase().includes("user") && (
        <Column
            body={(rowData) => (
                <div className="flex justify-content-center">
                    <InputSwitch
                        className="edit-btn ml-1 mt-2"
                        checked={rowData?.partIsActive === true}
                        onChange={() => {
                            handleSwitchModalOpen();
                            setSwitchData(rowData);
                        }}
                    />
                </div>
            )}
            header="Status"
            style={{ width: "90px" }}
        />
    )}

    {/* Actions */}
    <Column
        body={(rowData) => (
            <div className="flex justify-content-center">
                {!userRole?.toLowerCase().includes("user") && (
                    <Button className="edit-btn ml-1 px-2" onClick={() => handleEditParts(rowData)}>
                        <img src={editIcon} alt="Edit" />
                    </Button>
                )}
                <Button className="edit-btn ml-1 px-2" onClick={() => handleViewPart(rowData)}>
                    <img src={viewIcon} alt="View" />
                </Button>
                {!userRole?.toLowerCase().includes("user") && (
                    <Button
                        className="edit-btn ml-1 px-2"
                        onClick={() => {
                            handleOpenModal();
                            setPartsDataId(rowData.partId);
                        }}
                    >
                        <img src={deleteIcon} alt="Delete" />
                    </Button>
                )}
            </div>
        )}
        header="Action"
        style={{ width: "150px" }}
    />
</DataTable>

                        <Modal />
                    </div>
                    <Paginator setRecordCount={setRecordCount} setCurrentPage={setCurrentPage} setTotalPageCount={setTotalPageCount} recordCount={recordCount} currentPage={currentPage} totalPageCount={totalPageCount} quotationsCount={quotationsCount} />
                </>
            )}
        </>
    );
};

export default ManagePart;
